import { __module as defaultClassNames } from '../../../../../_virtual/default-class-names.js';

var hasRequiredDefaultClassNames;

function requireDefaultClassNames () {
	if (hasRequiredDefaultClassNames) return defaultClassNames.exports;
	hasRequiredDefaultClassNames = 1;
	(function (module, exports) {

		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		/**
		 * Default CSS class names
		 * @ignore
		 * @type {InputRangeClassNames}
		 */
		var DEFAULT_CLASS_NAMES = {
		  activeTrack: 'input-range__track input-range__track--active',
		  disabledInputRange: 'input-range input-range--disabled',
		  inputRange: 'input-range',
		  labelContainer: 'input-range__label-container',
		  maxLabel: 'input-range__label input-range__label--max',
		  minLabel: 'input-range__label input-range__label--min',
		  slider: 'input-range__slider',
		  sliderContainer: 'input-range__slider-container',
		  track: 'input-range__track input-range__track--background',
		  valueLabel: 'input-range__label input-range__label--value'
		};

		exports.default = DEFAULT_CLASS_NAMES;
		module.exports = exports['default'];
		
	} (defaultClassNames, defaultClassNames.exports));
	return defaultClassNames.exports;
}

export { requireDefaultClassNames as __require };
